<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">
      Manage Leave Requests
    </h3>

    <o-list-toolbar
      :filters-list="computed_filter_list"
      :search-fields-list="custom_search_fields_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'leave_request.create', params: { id: 0 } }"
      new-button-text="New Leave Request"
    >
      <template slot="middle">
        <!--o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /-->
      </template>
    </o-list-toolbar>

    <b-table
      striped
      bordered
      :fields="custom_fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header"
      @row-selected="onRowSelected"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        slot="top-row"
        slot-scope="{ columns, fields }"
        v-if="filterRow"
      >
        <td :key="field.key" class="p-0" v-for="field in fields">
          <span v-if="field.key === 'created_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.created_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'date_created'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.date_created"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'details'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.details"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'end_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.end_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'modified_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.modified_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'staff_member'">
            <o-form-select
              v-model="list_options.qbe.staff_member"
              :options="optionEmployeeItems"
              text-field="full_name"
              value-field="id"
              sort-field="full_name"
              blank-option-text=""
              :loading="optionEmployeeWorking"
              @change="filter_changed"
              name="staff_member"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'start_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.start_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'start_time'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.start_time"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'end_time'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.end_time"
            ></b-form-input>
          </span>
        </td>
      </template>
      <template slot="cell(leave_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="isStaff === true"
        >
          <p class="leaveTypeColumn" v-for="type in item.leave_type">
            {{ type.leave_type__description }}

            {{ moment(type.start_date) }}
            <span v-if="type.start_time && type.end_time">
              {{ type.start_time }} - {{ type.end_time }}
            </span>
            {{ moment(type.end_date) }}
          </p>

          <span v-if="item.comments">
            {{ item.comments }}
          </span>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.created_date"
          format="DD/MM/YYYY"
        ></date-display>
      </template>
      <template slot="cell(date_created)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_created'"
        >
          <date-display
            :value="item.date_created"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(details)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'details'"
        >
          <default-display :value="item.details"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'end_date'"
        >
          <date-display
            :value="item.end_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(start_time)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'start_time'"
        >
          <default-display
            :value="convert_time(item.start_time)"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(end_time)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'end_time'"
        >
          <default-display
            :value="convert_time(item.end_time)"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(rejected)" slot-scope="{ index, item }">
        <span
          class="badge badge-danger"
          v-if="
            item.status === LEAVE_STATUS.MANAGER_REJECT ||
            (item.status === LEAVE_STATUS.PAYROLL_REJECTED &&
              getRejectedColumn(item))
          "
        >
          <h6>
            <default-display :value="getRejectedColumn(item)"></default-display>
          </h6>
        </span>
        <br />
        <default-display :value="getRejectedFullName(item)"></default-display>
      </template>
      <template slot="cell(approved)" slot-scope="{ index, item }">
        <span
          class="badge badge-success"
          v-if="
            item.status === LEAVE_STATUS.PAYROLL_APPROVE &&
            getApprovedColumn(item)
          "
        >
          <h6>
            <default-display :value="getApprovedColumn(item)"></default-display>
          </h6>
        </span>
        <br />
        <default-display :value="getApprovedFullName(item)"></default-display>
      </template>
      <template slot="cell(cancelled)" slot-scope="{ index, item }">
        <span class="badge badge-warning" v-if="getCancelledColumn(item)">
          <h6>
            <default-display
              :value="getCancelledColumn(item)"
            ></default-display>
          </h6>
        </span>
        <br />
        <default-display :value="getCancelledFullName(item)"></default-display>
      </template>
      <template slot="cell(note)" slot-scope="{ index, item }">
        <default-display :value="getNoteColumn(item)"></default-display>
      </template>
      <template slot="cell(_full_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
        >
          <default-display :value="item._full_name"> </default-display>
        </o-link-cell>
      </template>
      <template slot="cell(staff_member)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'staff_member'"
        >
          <lookup-display
            :list="optionEmployeeItemsById"
            :value="item.staff_member"
            display-field="full_name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'start_date'"
        >
          <date-display
            :value="item.start_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(comments)="{ index, item }">
        <o-link-cell
          :to="{ name: 'leave_request.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <default-display
            :value="item.comments"
            default-value="-"
          ></default-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'leave_request.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style>
.leaveTypeColumn {
  margin-top: 0%;
  margin-bottom: 0%;
}
</style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import UserMixin from "../../mixins/UserMixin";
import { mapGetters } from "vuex";
import moment from "moment";
import * as LEAVE_TASK_STATUS from "../../leave_task_status.js";
import * as LEAVE_STATUS from "../../leave_status.js";
import * as LEAVE_TASK_TYPES from "../../leave_task_types.js";
export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("LeaveRequest", "leave_request"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("LeaveRequest"),
    CreateCodeTableFetchMixin(["Employee", "EmployeeManager"]),
    UserMixin,
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.LeaveRequest,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.LeaveRequest),

      filterRow: true /* Set to False to disable filter row */,
      // filter_list: [
      //   /* { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
      //   {
      //     name: "Non Active",
      //     code: "inactive",
      //     options: { offset: 0, sort: "id" },
      //   }, */
      //   { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      //   {
      //     name: "My Leave Requests",
      //     code: "my_leave_requests",
      //     options: { offset: 0, sort: "id" },
      //   },
      //   {
      //     name: "Need HR Approval",
      //     code: "need_manager_approval",
      //     options: { offset: 0, sort: "id" },
      //   },
      // ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  methods: {
    convert_time(time) {
      if (time) return moment(time, "HH:mm:ss").format("hh:mm A");
      else return "";
    },
    getRejectedColumn(item) {
      // If rejected by manager
      // If rejected by payroll
      let manager_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.MANAGER_APPROVAL
      );
      let payroll_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
      );

      if (manager_approval_task !== undefined) {
        if (manager_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
          return moment(manager_approval_task["when"]).format("DD/MM/YYYY");
      }

      if (payroll_approval_task !== undefined) {
        if (payroll_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
          return moment(payroll_approval_task["when"]).format("DD/MM/YYYY");
      }

      return "";
    },
    getApprovedColumn(item) {
      let payroll_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
      );

      if (payroll_approval_task !== undefined) {
        if (payroll_approval_task["status"] === LEAVE_TASK_STATUS.APPROVED)
          return moment(payroll_approval_task["when"]).format("DD/MM/YYYY");
      }

      return "";
    },
    getCancelledColumn(item) {
      let cancel_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
      );

      if (cancel_approval_task !== undefined) {
        // Request approved by manager and then cancelled
        if (cancel_approval_task["status"] === LEAVE_TASK_STATUS.APPROVED)
          return moment(cancel_approval_task["when"]).format("DD/MM/YYYY");
        // Request approved by manager and then cancel was rejected
        if (cancel_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
          return "Cancel Rejected";
        // Request not approved by manager and then cancelled
        if (
          cancel_approval_task["status"] === LEAVE_TASK_STATUS.PENDING &&
          item.status === LEAVE_STATUS.CANCEL_APPROVED
        )
          return moment(cancel_approval_task["created_date"]).format(
            "DD/MM/YYYY"
          );
      } else return null;
    },
    getNoteColumn(item) {
      // If rejected by manager, show manager_approval_task["note"]
      // If approved by payroll, show payroll_approval_task["note"]
      // If rejected by payroll, show payroll_approval_task["note"]

      let manager_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.MANAGER_APPROVAL
      );
      let payroll_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
      );
      let cancel_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
      );

      if (manager_approval_task !== undefined) {
        if (manager_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
          return manager_approval_task["note"];
      }
      if (
        payroll_approval_task !== undefined &&
        (!cancel_approval_task ||
          cancel_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
      ) {
        if (
          payroll_approval_task["status"] === LEAVE_TASK_STATUS.APPROVED ||
          payroll_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED
        )
          return payroll_approval_task["note"];
      }
      if (cancel_approval_task !== undefined) {
        if (cancel_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
          return cancel_approval_task["note"];
      }

      return "";
    },
    moment(dateString) {
      return moment(dateString, "YYYY-MM-DD").format("DD/MM/YYYY").toString();
    },
    getRejectedFullName(item) {
      // Return full name of the user (manager/payroll) who rejected the request

      let manager_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.MANAGER_APPROVAL
      );
      let payroll_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
      );

      // Rejected by Manager
      if (manager_approval_task !== undefined) {
        if (manager_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED) {
          let manager = manager_approval_task["who"];
          if (this.optionEmployeeItemsById[manager])
            return this.optionEmployeeItemsById[manager]["full_name"];
        }
      }

      // Rejected by Payroll
      if (payroll_approval_task !== undefined) {
        if (payroll_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED) {
          let payroll = payroll_approval_task["who"];
          if (this.optionEmployeeItemsById[payroll])
            return this.optionEmployeeItemsById[payroll]["full_name"];
        }
      }

      return "";
    },
    getCancelledFullName(item) {
      // Return full name of the user (manager) who approved the cancellation

      let cancel_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
      );

      if (cancel_approval_task !== undefined) {
        let manager = cancel_approval_task["who"];
        if (this.optionEmployeeItemsById[manager])
          return this.optionEmployeeItemsById[manager]["full_name"];
      }
    },
    getApprovedFullName(item) {
      // Return full name of the user (payroll) who approved the request

      let payroll_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
      );
      let manager_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.MANAGER_APPROVAL
      );
      let cancel_approval_task = item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
      );

      if (payroll_approval_task !== undefined) {
        if (
          payroll_approval_task["status"] === LEAVE_TASK_STATUS.APPROVED &&
          (!cancel_approval_task ||
            cancel_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
        ) {
          let manager = manager_approval_task["who"];
          // let payroll = payroll_approval_task["who"];
          if (this.optionEmployeeItemsById[manager])
            return this.optionEmployeeItemsById[manager]["full_name"];
        }
      }

      return "";
    },
  },
  computed: {
    ...mapGetters("AuthModule", ["currentUser"]),
    LEAVE_STATUS() {
      return LEAVE_STATUS;
    },
    options() {
      return {
        Employee: {
          options: this.optionEmployeeItems,
          textField: "full_name",
          valueField: "id",
        },
      };
    },
    custom_fields() {
      if (this.isStaff) {
        var columns = [];

        columns = [
          {
            key: "leave_type",
            label: "Leave Types",
            sortable: true,
          },
          {
            key: "start_date",
            label: "From",
            sortable: true,
          },
          {
            key: "end_date",
            label: "To",
            sortable: true,
          },
          {
            key: "created_date",
            label: "Created Date",
            sortable: true,
          },
          {
            key: "approved",
            label: "Approved",
            sortable: false,
          },
          {
            key: "rejected",
            label: "Rejected",
            sortable: false,
          },
          {
            key: "cancelled",
            label: "Cancelled",
            sortable: false,
          },
          {
            key: "note",
            label: "Note",
            sortable: false,
          },
          {
            key: "comments",
            label: "Comments",
            sortable: false,
          },
        ];

        return columns;
      }

      return [
        {
          key: "_full_name",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "leave_type",
          label: "Leave Types",
          sortable: true,
        },
        {
          key: "start_date",
          label: "From",
          sortable: true,
        },
        {
          key: "end_date",
          label: "To",
          sortable: true,
        },
        {
          key: "created_date",
          label: "Created Date",
          sortable: true,
        },
        {
          key: "approved",
          label: "Approved",
          sortable: false,
        },
        {
          key: "rejected",
          label: "Rejected",
          sortable: false,
        },
        {
          key: "cancelled",
          label: "Cancelled",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "comments",
          label: "Comments",
          sortable: false,
        },
      ];
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "staff_member",
        "start_date",
        "end_date",
        "created_date",
        "start_time",
        "end_time",
        "comments",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
    custom_search_fields_list() {
      let custom = this.search_field_list;

      if (this.isManager || this.isPayroll || this.isAdministrator) {
        custom.push({ text: "First Name", value: "staff_member__first_name" });
        custom.push({ text: "Last Name", value: "staff_member__last_name" });
        custom.push({ text: "Code", value: "staff_member__code" });
        custom.push({
          text: "Email Address",
          value: "staff_member__email_address",
        });
        return custom;
      } else return this.search_field_list;
    },
    computed_filter_list() {
      var filters = [
        {
          name: "My Leave Requests",
          code: "my_leave_requests",
          options: { offset: 0, sort: "start_date", order: "desc" },
        },
        {
          name: "Need Manager Approval",
          code: "need_manager_approval",
          options: { offset: 0, sort: "start_date", order: "desc" },
        },
        {
          name: "Leave Cancelled",
          code: "cancelled",
          options: { offset: 0, sort: "start_date", order: "desc" },
        },
        {
          name: "Cancelled Leave Requiring Approval",
          code: "cancelled_leave_requiring_approval",
          options: { offset: 0, sort: "start_date", order: "desc" },
        },
      ];

      if (this.isManager || this.isAdministrator) {
        filters.push(
          {
            name: "Approved by Manager",
            code: "approved_by_manager",
            options: { offset: 0, sort: "start_date", order: "desc" },
          },
          {
            name: "Rejected by Manager",
            code: "rejected_by_manager",
            options: { offset: 0, sort: "start_date", order: "desc" },
          }
        );
      }

      if (this.isPayroll || this.isAdministrator) {
        filters.push(
          {
            name: "Need Payroll Approval",
            code: "need_payroll_approval",
            options: { offset: 0, sort: "start_date", order: "desc" },
          },
          {
            name: "Approved by Payroll",
            code: "approved_by_payroll",
            options: { offset: 0, sort: "start_date", order: "desc" },
          },
          {
            name: "Rejected by Payroll",
            code: "rejected_by_payroll",
            options: { offset: 0, sort: "start_date", order: "desc" },
          }
        );
      }

      if (this.isAdministrator) {
        filters.push({
          name: "All",
          code: "all",
          options: { offset: 0, sort: "start_date", order: "desc" },
        });
      }

      return filters;
    },
  },
};
</script>
